import React, { useState, useEffect } from 'react';
import Header from '../../component/layout/Header';
import Footer from '../../component/layout/Footer';
import Page from '../../component/utility/Page';
import DataTable from 'react-data-table-component';
import { custTableStyles } from '../../style/color';
import axios from 'axios';
import { mainurl, imgurl } from '../../Mainurl';
import AddEventSubject from '../../component/utility/master/AddEventSubject';

import { Row, Col, Card, CardHeader, CardBody, FormGroup, Input, Label, InputGroup, InputGroupText, Spinner, Button } from 'reactstrap';
import { FaEye, FaEdit, FaPlusCircle, FaClipboardList } from 'react-icons/fa';

const EventSubjectMaster = () => {
    const [mode, setMode] = useState(1);
    const [loading, setLoading] = useState(false);
    const [tableData, setTableData] = useState([]);
    const [subjectData, setSubjectData] = useState('');
    const [topic, setTopic] = useState('');
    const [topicOpt, setTopicOpt] = useState('');

    useEffect(() => {
        get_topic_list();
    }, [])

    const get_topic_list = () => {
        setTopicOpt('');
        let postData = [{ "org_id": sessionStorage.getItem('org_id'), "user_id": sessionStorage.getItem('user_id'), "lang_id": 1 }];
        axios({
            method: 'post',
            url: mainurl + 'Master/box_event_subject_list',
            data: postData,
            headers: { 'Content-Type': 'application/JSON', }
        })
            .then(function (response) {
                let list = response.data.map((row, index) => {
                    return (
                        <option value={row.event_topic_id}> {row.topic_desc}</option>
                    )
                });

                setTopicOpt(list);
                setSubjectData(response.data);

            })
            .catch(error => {
                setLoading(false);
                //let notify = notification({ message: "User list not Found! Try Again", type: 'error' });
                //notify();
            });
    }

    const get_subject_list = (e) => {
        let subjectFilterData = subjectData.filter((row) => row.event_topic_id === topic);
        let list = subjectFilterData[0].subject_list?.map((row, index) => {
            return (
                {
                    sl: index + 1,
                    name: row.subject_desc,
                    name_h: row.subject_desc_ne,
                    event_topic_id: row.event_topic_id == 1 ? "Training" : row.event_topic_id == 2 ? "Meeting" : "N/A",
                    status: <div className='text-primary'>Active</div>,
                }
            )
        });
        setTableData(list);
    }


    const back_handler = () => {
        get_topic_list();
        setMode(1);
    }
    return (
        <>
            <Header />
            <Page title='Event Subject' breadcrumbs='Home / Event Topic'>
                {mode === 1 &&
                    <Row className='p-3'>
                        <Col xs={12}>
                            <Card className='mb-3' color="primary" outline>
                                <CardBody>
                                    <Row>
                                        <Col sm={3} className="mb-2">
                                            <Label for="type"> Topic </Label>
                                            <Input id="type" bsSize="sm" type="select" value={topic} onChange={(e)=> setTopic(e.target.value)}>
                                                <option value="0"> --Select Topic--</option>
                                                {topicOpt}
                                            </Input>
                                        </Col>
                                        <Col md={2}>
                                            <Button className='text-white mt-4' color='primary' size="sm" block onClick={get_subject_list}> <FaClipboardList className='me-1' size={20} /> Get List</Button>
                                        </Col>
                                        <Col md={3}>
                                            <Button className='text-white mt-4' color='primary' size="sm" block onClick={() => setMode(2)}>
                                                <FaPlusCircle className='me-1' size={20} />
                                                Add New Event Subject
                                            </Button>
                                        </Col>
                                    </Row>
                                </CardBody>
                            </Card>
                        </Col>
                        <Col md={{ offset: 2, order: 2, size: 8 }}>
                            <Card className='' color="primary" outline>
                                <CardBody>
                                    <DataTable
                                title=""
                                customStyles={custTableStyles}
                                columns={[
                                    {
                                    name: '#',
                                    selector: row=>row.sl,
                                    sortable: true,
                                    width: '80px'
                                    },
                                    {
                                    name: 'Subect Name',
                                    selector: row=>row.name,
                                    sortable: false,
                                    },
                                    {
                                    name: 'Subject Name Hindi',
                                    selector: row=>row.name_h,
                                    sortable: false,
                                    },
                                    {
                                    name: 'Event Type',
                                    selector: row=>row.event_topic_id,
                                    sortable: false,
                                    },
                                    {
                                    name: 'Status',
                                    selector: row=>row.status,
                                    sortable: false,
                                    },
                                ]}
                                data={tableData}
                                highlightOnHover
                                progressPending={loading}
                                />
                                </CardBody>
                            </Card>
                        </Col>

                    </Row>
                }
                {mode === 2 &&
                    <Col xs={12} className='p-3'>
                        <AddEventSubject back={() => back_handler()} />
                    </Col>
                }
            </Page>
            <Footer />

        </>
    )
}

export default EventSubjectMaster;